import React from 'react';
import styled from 'styled-components';
import { VideosHero, VideoSection } from '../components/video';
import { FloatingPattern } from '../components/common';
import { theme } from '../theme/theme';

const PageContainer = styled.div`
    position: relative;
    padding-top: 70px;
    overflow-x: hidden;
`;

// Video data
const fancyTownCredits = [
    { name: 'Tyler Vander Maas', role: 'Lead vocals, Songwriter' },
    { name: 'Adam Marth', role: 'Guitar' },
    { name: 'Dutcher Snedeker', role: 'Keys' },
    { name: 'Kevin Pritchard', role: 'Bass' },
    { name: 'Richard Hale', role: 'Drums' },
    { name: 'Ryan Hoger', role: 'Director, Editor' },
    { name: 'Kait Rose', role: 'Backing vocals' },
];

export const VideoPage: React.FC = () => {
    return (
        <PageContainer>
            <FloatingPattern />
            <VideosHero />

            {/* Video 1: Fancy Town */}
            <VideoSection
                videoSrc="https://d110v70ry4kxfb.cloudfront.net/video/fancy-town.mp4"
                videoPoster="/images/video-thumbnails/fancy-town-thumbnail.jpg"
                videoTitle="Fancy Town"
                videoDescription="A comedic journey through the ups and downs of trying to fit in with the fancy crowd. Shot on location in Grand Rapids, Michigan."
                credits={fancyTownCredits}
                videoPosition="left"
                backgroundColor={theme.colors.backgroundLighter}
            />
        </PageContainer>
    );
};
